module.exports = "<span [class.bg]=\"authenticationService.isLoggedIn()\">\n  © 2018 CARTO. All rights reserved\n  <ng-container *ngIf=\"showGeographica\"> \n    · Engineered by <a href=\"https://geographica.gs\" target=\"_blank\">Geographica</a>\n  </ng-container>\n</span>\n<a target=\"_blank\" href=\"https://carto.com\">\n  <img class=\"CARTO-logo\" src=\"/assets/logos/carto-logo.svg\"/>\n</a>\n<!-- <latitude-ui-geo-logo-mini *ngIf=\"showGeographica\" [geoHeight]=\"24\"></latitude-ui-geo-logo-mini> -->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/footer/footer.component.html
// module id = ./src/app/common/footer/footer.component.html
// module chunks = main